<template>
  <commonModal :show.sync="config" isHideFooter :width="800" :styles="{ maxHeight:'600px', overflow: 'auto'}">
      <div class="modal-header" slot="header">订单详情</div>
      <div class="relative" style="margin-top: 30px">
        <loading :loading="orderLoading" background="transparent" color="#c4332e" style="z-index: 120"></loading>
        <Table :columns="columns" :data="list"></Table>
      </div>
    </commonModal>
</template>

<script>
import { orderDetail } from "api/domain.js";
import commonModal from "components/commonModal/index.vue";
import loading from "components/loading.vue";
export default {
  name: "orderInfoModal",
  components:{
    commonModal,
    loading
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        {
          width: "80",
          title: "序号",
          type: "index",
        },
        {
          width: 200,
          title: "产品名称",
          key: "goodsName",
          align: "center",
        },
        {
          title: "产品类型",
          key: "type",
          align: "center",
          render: (h, { row }) => {
            let title = "";
            switch (row.type) {
              case 0:
                title = "注册";
                break;
              case 1:
                title = "续费";
                break;
              case 2:
                title = "转入";
                break;
            }
            return h("div", title);
          },
        },
        {
          title: "单价",
          key: "price",
          align: "center",
          render: (h, { row }) => {
            return h("div", row.price + "元/年");
          },
        },
        {
          title: "数量",
          key: "counts",
        },
        {
          title: "总价",
          key: "amount",
          render: (h, { row }) => {
            return h("div", row.amount + "元");
          },
        },
      ],
      list: [],
      orderLoading: false,
    };
  },
  computed: {
    config: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  watch: {
    config: {
      immediate: true,
      handler(val) {
        if (val) {
          this.req_orderDetail();
        }
      },
    },
  },
  methods: {
    async req_orderDetail() {
      try {
        this.orderLoading = true;
        const { code, data } = await orderDetail({ orderNo: this.id });
        this.orderLoading = false;
        if (code === 200) {
          this.list = data.orderDetailList;
        }
      } catch (error) {
        this.orderLoading = false;
        console.log(error);
      }
    },
  },
};
</script>
